import { trackEvent } from '@patrianna/analytics'
import type { PWAEventType } from '@patrianna/shared-patrianna-types/store/AppConfigModule'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'

import content from 'prismic-translates/pwa-provider.json'
import Button from 'src/components/Button'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

type Props = {
  pwaInstance: PWAEventType | { prompt: () => void }
}

function PWAInfo(props: Props) {
  const openDialog = () => {
    props.pwaInstance.prompt()
    trackEvent('main_menu_install_button_click')
  }

  return (
    <div className={classes.root}>
      <img
        className={classes.icon}
        src={`${process.env.IMG_ORIGIN}/pwa_icon_${process.env.BRAND_NAME}.png`}
        alt='pwa icon'
      />
      <Button variant='outlined' size='small' className={classes.button} onClick={openDialog} data-test='pwa-button'>
        {t('install')}
      </Button>
    </div>
  )
}

export default PWAInfo
